import type { RouteRecordRaw } from 'vue-router';

export const errorRoutes: RouteRecordRaw[] = [
  {
    path: '/service-down',
    name: 'service-down',
    component: () => import('@/pages/ProblemPages/ServiceDown.vue'),
  },
  {
    path: '/not-found',
    name: 'not-found',
    component: () => import('@/pages/ProblemPages/NotFound.vue'),
  },
  {
    path: '/problem',
    name: 'problem',
    component: () => import('@/pages/ProblemPages/ProblemPage.vue'),
  },
  {
    path: '/no-organization',
    name: 'no-organization',
    component: () => import('@/pages/ProblemPages/NoOrganization.vue'),
  },
  {
    path: '/signup-pending',
    name: 'signup-pending',
    component: () => import('@/pages/ProblemPages/SignupPending.vue'),
  },
];
